import React from "react";
import Accordion from "./HomePage/FAQ/Accordion";
import QuestionAnswer from "./HomePage/FAQ/QuestionAnswer";
import LearnMore from "./HomePage/LearnMore/LearnMore";
import Home from "./HomePage/MasterHeroPage/Home";
import PopularShops from "./HomePage/PopularItems/PopularShops";
import Product from "./HomePage/ProductCategory/PopularProducts/Product";
// import ProductCat from "./HomePage/ProductCategory/PopularProducts/ProductCatSwiper";
import RelyShoppy from "./HomePage/RelyOnShoppy/RelyShoppy";
import ShoppyAbout from "./HomePage/whyShoppy/ShoppyAbout";
// import TailwindSlder from "./HomePage/whyShoppy/TailwindSlder";

const HomePage = () => {
  return (
    <div>
      <Home />
      {/* <Product /> */}
      {/* <ProductCat /> */}
      <Product />
      <PopularShops />
      <LearnMore />
      <ShoppyAbout />
      <RelyShoppy />
      {/* <Accordion /> */}
      <QuestionAnswer />
      {/* <TailwindSlder /> */}
    </div>
  );
};

export default HomePage;
